module.exports = __webpack_public_path__ + "img/discover.849342a.svg";